import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';
import Carrier from '../../models/Carrier';


export interface CarrierDetailState extends ApiState {
  carrier?: Carrier
}

export default requestReducer<CarrierDetailState>('CARRIER_DETAIL')
